<script lang="tsx">
  import { PropType, defineComponent } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerDivider from '@xhs/yam-beer/cmp/common/Divider/Divider.vue'

  export default defineComponent({
    name: 'BeerTitle',
    props: {
      /**
       * @ignore
       * 容器 BS
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * Title 级别； 1，2
       */
      level: {
        type: Number as PropType<number>,
        default: 1,
      },
      /**
       * 是否显示底部分割线
       */
      divider: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },
    setup(props, { slots, attrs }) {
      return () => {
        const { bs, divider } = props

        const levelBs = props.level === 1
          ? {
            height: 32,
            fontSize: '20px',
            pl: 13,
            '&::before': {
              position: 'absolute',
              left: 0,
              width: 5,
              top: 7,
              bottom: 7,
              borderRadius: 16,
              overflow: 'hidden',
              bg: 'brand',
              content: '""',
            },
          }
          : {
            height: 24,
            fontSize: '16px',
          }
        const wrapperBs = {
          bg: 'white',
          ...bs,
          '.level-wrapper': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            ...levelBs,
          },
          '.title-medium': {
            fontWeight: 'medium',
          },
        }
        return (
          <NewBsBox
            bs={wrapperBs}
            {...{
              ...attrs,
            }}
          >
            <div class="level-wrapper">
              <div class="title-medium">
                {slots.default?.()}
              </div>
              {slots.action?.()}
            </div>
            { divider && <BeerDivider bs={{ mt: 10 }} hairLine /> }
          </NewBsBox>
      )
      }
    },
  })
</script>
